import { signal } from "@preact/signals-react"

export const isEmpty = signal(false)
export const showMoreTags = signal(null)
export const evolutionDataFilters = signal({})
export const evolutionChartCurrentPeriod = signal("")
export const dataDetails = signal([])
export const dataDetailsFiltered = signal([])
export const filterBrandTitle = signal("")
export const elementsInLoading = signal([])
export const shareOfSearchDetailsEndDate = signal("")

export const resetShareOfSearchDetailsSignals = () => {
    evolutionDataFilters.value = {}
    dataDetails.value = []
    dataDetailsFiltered.value = []
    filterBrandTitle.value = ""
    elementsInLoading.value = []
}